import axios from "axios";
import { addStudentURL, listStudentURL, getStudentByIdURL, updateStudentURL, getAllGuardianPaginateURL, learningPathwayURL, studentWorkURL, downloadStudentWorksheetsURL, studentURL, studentsURL, adhocPrintURL, adhocPrintHistoryURL, studentFeesCreditsURL, studentInvoiceURL, studentWorkWeeksListURL } from "@app/constants/ApiEndPoints";

export const addStudentService = async (payload) => {
	try {
		const response = await axios.post(addStudentURL, payload);
		if (response.status === 201 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getAllStudentWithPaginationService = async (search) => {
	try {
		const response = await axios.get(listStudentURL + `?${search.toString()}`);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const exportStudentsByFilter = async (search) => {
	try {
		const response = await axios.get(listStudentURL + `/export/all?${search.toString()}`);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentById = async (id: number) => {
	try {
		const response = await axios.get(getStudentByIdURL + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateStudent = async (id, payload) => {
	try {
		const response = await axios.put(updateStudentURL + id, payload);
		if (response.status === 201 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getAllParentWithPaginationService = async (page, perPage, sortField, sortDirection, search) => {
	try {
		const response = await axios.get(getAllGuardianPaginateURL + `?page=${page}&perPage=${perPage}&sortField=${sortField}&sortDirection=${sortDirection}&firstName=${search.first_name}&lastName=${search.last_name}&franchise=${search.franchise_id}&status=${search.status}&email=${search.email}`);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentRollNumberCounter = async (payload) => {
	try {
		const response = await axios.post(studentsURL + 'roll-number/counter', payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudAssignWorkById = async (payload) => {
	try {
		const response = await axios.post(learningPathwayURL + 'student/work', payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const processStudentWork = async (payload) => {
	try {
		const response = await axios.post(studentWorkURL + 'create/work', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentWorkSummaryById = async (payload) => {
	try {
		const response = await axios.post(studentWorkURL + 'work/summary', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const downloadStudentWorksheets = async (payload) => {
	try {
		const response = await axios.post(downloadStudentWorksheetsURL, payload, { responseType: 'blob' });
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentWorkHistoryWithPagination = async (studId, page, perPage, sortField, sortDirection, search) => {
	try {
		const response = await axios.get(studentWorkURL + studId + `/work/history?page=${page}&perPage=${perPage}&sortField=${sortField}&sortDirection=${sortDirection}&moduleId=${search.moduleId}&fromDate=${search.fromDate}&toDate=${search.toDate}`);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentSubjectsById = async (studId) => {
	try {
		const response = await axios.get(studentURL + 'subjects/' + studId);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentActiveSubjectsById = async (studId) => {
	try {
		const response = await axios.get(studentURL + 'subjects/' + studId + '/active');
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

/**
 * GET /admin/students/subjects/:id?status=active
 * Returns only active subjects for a student (matches the auto-mark API screenshot)
 */
export const getStudentSubjectsByStatusActive = async (studId) => {
	try {
		const response = await axios.get(studentURL + 'subjects/' + studId + '?status=active');
		if (response.status === 200) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentActiveAndUpcomingSubjectsById = async (studId) => {
	try {
		const response = await axios.get(studentURL + 'subjects/' + studId + '?status=active,upcoming');
		if (response.status === 200) {
			return response.data
		}
	} catch (error) {
		// Return a consistent error structure even for network/parsing errors
		return error?.response?.data || { success: false, errors: [{ msg: 'Unable to load student subjects' }] };
	}
};

export const downloadStudentWeekSummary = async (payload) => {
	try {
		const response = await axios.post(studentWorkURL + 'weeks/summary', payload, { responseType: 'blob' });
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const downloadStudentHandbookSummary = async (payload) => {
	try {
		const response = await axios.post(learningPathwayURL + 'student/weeks/handbook-summary', payload, { responseType: 'blob' });
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const downloadStudentHandbooksByWeeks = async (payload) => {
	try {
		const response = await axios.post(downloadStudentWorksheetsURL + '/handbook', payload, { responseType: 'blob' });
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const downloadStudentHandbooksByWorksheets = async (payload) => {
	try {
		const response = await axios.post(downloadStudentWorksheetsURL + '/handbook/history', payload, { responseType: 'blob' });
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const createStudentWSPrintHistory = async (payload) => {
	try {
		const response = await axios.post(studentWorkURL + 'print/history', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updatePrinterStatusByHistoryId = async (payload) => {
	try {
		const response = await axios.put(studentWorkURL + 'print/history', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const addWSToPrintQueue = async (payload) => {
	try {
		const response = await axios.post(adhocPrintURL, payload);
		if (response.status === 201 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getPrintQueueByStudentId = async (id: number) => {
	try {
		const response = await axios.get(adhocPrintURL + '/' + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const clearPrintQueueByStudentId = async (id) => {
	try {
		const response = await axios.get(adhocPrintURL + '/clear/' + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const deleteItemFromPrintQueue = async (id: number) => {
	try {
		const response = await axios.get(adhocPrintURL + '/clear/item/' + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const downloadStudentAdhocWorksheets = async (id) => {
	try {
		const response = await axios.get(adhocPrintURL + '/preview/' + id, { responseType: 'blob' });
		// const response = await axios.get('http://13.40.177.40/api/v1/admin/students/print/preview/' + id, { responseType: 'blob' });
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const createStudAdhocWSPrintHistory = async (payload) => {
	try {
		const response = await axios.post(adhocPrintHistoryURL + 'create/history', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateStudAdhocWSPrinterStatus = async (payload) => {
	try {
		const response = await axios.post(adhocPrintHistoryURL + 'update/history', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentsByFranchiseId = async (id: number) => {
	try {
		const response = await axios.get(studentURL + '/franchise/' + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentsByFranchiseCentreSubject = async (franchiseId: number, centreId: number | null, subjectId: number) => {
	try {
		const params = new URLSearchParams();
		params.append('franchise_id', franchiseId.toString());
		if (centreId) {
			params.append('centre_id', centreId.toString());
		} else {
			params.append('centre_id', '');
		}
		params.append('subject_id', subjectId.toString());

		const response = await axios.get(studentURL + 'franchise-centre-subject?' + params.toString());
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateStudentSubject = async (studId, payload) => {
	try {
		const response = await axios.put(studentURL + 'subjects/' + studId, payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}

};

export const getStudentSubjectHistory = async (payload) => {
	try {
		const response = await axios.post(studentURL + 'subjects/history', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getFeesAndCreditsByStudentWithPagination = async (page, perPage, sortField, sortDirection, search) => {
	try {
		const response = await axios.get(studentFeesCreditsURL + `?page=${page}&perPage=${perPage}&sortField=${sortField}&sortDirection=${sortDirection}
															&studentId=${search.studentId}&vatIncluded=${search.vatIncluded}&amount=${search.amount}&status=${search.status}`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const addFeesCredits = async (payload) => {
	try {
		const response = await axios.post(studentFeesCreditsURL + '/create', payload);
		if (response.status === 201 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const deleteFeesCreditById = async (id: number) => {
	try {
		const response = await axios.delete(studentFeesCreditsURL + '/' + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentInvoicesWithPagination = async (search) => {
	try {
		const response = await axios.get(studentInvoiceURL + `?${search.toString()}`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentInvoiceDetailsById = async (id) => {
	try {
		const response = await axios.get(studentInvoiceURL + `/${id}/details`);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const genarateStudentRecurringInvoices = async (payload) => {
	try {
		const response = await axios.post(studentInvoiceURL + '/recurring', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const downloadStudentInvoice = async (invoiceId) => {
	try {
		const response = await axios.get(studentInvoiceURL + `/${invoiceId}/file`, { responseType: 'blob' });
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentsByParentId = async (id: number) => {
	try {
		const response = await axios.get(studentURL + 'parent/' + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateStudentInvoicePayment = async (payload) => {
	try {
		const response = await axios.post(studentInvoiceURL + '/make/payment', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const cancelStudentInvoiceById = async (id: number) => {
	try {
		const response = await axios.get(studentInvoiceURL + `/${id}/cancel`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data;
		}
		return response?.data;
	} catch (error) {
		return error?.response?.data;
	}
};

export const previewStudentRecurringInvoices = async (payload) => {
	try {
		const response = await axios.post(studentInvoiceURL + '/preview/recurring', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const sendStudentBulkEmailInvoices = async (payload) => {
	try {
		const response = await axios.post(studentInvoiceURL + '/send-message', payload);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const reverseStudentInvoice = async (id) => {
	try {
		const response = await axios.get(studentInvoiceURL + `/${id}/reverse`);
		if (response.status === 200 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};


export const getStudentsByCentreAndSubject = async (params: { franchise_id: string; centre_id?: string; subject_id: string }) => {
	try {
		const response = await axios.get(studentsURL + 'by-centre-subject', { params });
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentsByQuery = async (params: { franchise_id: number; centre_id?: number; session_date: string }) => {
	try {
		const queryParams = new URLSearchParams();
		queryParams.append('franchise_id', params.franchise_id.toString());
		if (params.centre_id) {
			queryParams.append('centre_id', params.centre_id.toString());
		}
		queryParams.append('session_date', params.session_date);

		const response = await axios.get(studentsURL + `query?${queryParams.toString()}`);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const moveStudentWorkAhead = async (payload) => {
	try {
		const response = await axios.post(learningPathwayURL + 'student/work/move-week', payload);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentWorkSummaryHistory = async (payload) => {
	try {
		const response = await axios.post(learningPathwayURL + 'student/work/history-summary', payload);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentModulesBySubject = async (payload) => {
	try {
		const response = await axios.post(learningPathwayURL + 'student/modules-by-subject', payload);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentModuleCompletedList = async (params) => {
	try {
		const response = await axios.get(learningPathwayURL + 'student/work/history-summary-module', { params });
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const createStudentHandbookPrintHistory = async (payload) => {
	try {
		const response = await axios.post(learningPathwayURL + 'student/handbook/print/history', payload);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateHandbookPrinterStatusByHistoryId = async (payload) => {
	try {
		const response = await axios.put(learningPathwayURL + 'student/handbook/print/history', payload);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudentWorkWeeksList = async (payload: { student_id: number; subject_id: number; module_id?: string }) => {
	try {
		const response = await axios.post(studentWorkWeeksListURL, payload);
		if (response.status === 200) return response.data;
	} catch (error) {
		return error?.response?.data;
	}
};
